import React, { Component } from 'react'
import { connect } from 'react-redux'
import * as actions from '../../../Cereal/actions'
import { Field } from 'redux-form'
import { renderSelectField } from '../../fieldRenderers'

class CerealDropdown extends Component {
  constructor (props) {
    super(props)
    this.renderCereales = this.renderCereales.bind(this)
    this.onSelect = this.onSelect.bind(this)
  };

  componentDidMount () {
    const {
      cerealInicial = null,
      cerealesDeshabilitados = false
    } = this.props
    if (!cerealesDeshabilitados) {
      this.props.requestCerealEspecies()
    } else {
      this.props.requestCerealEspeciesConDeshabilitados()
    }
    if (cerealInicial) {
      this.props.setCerealEspecie(cerealInicial)
    }
  };

  onSelect (cerealEspecie) {
    if (cerealEspecie) {
      this.props.setCerealEspecie(cerealEspecie.target.value)
    }
  }

  renderCereales () {
    const {
      cerealEspecies,
      textPlaceHolder = null
    } = this.props
    return [
      (
        <option
          value='UNDEF'
          key='UNDEF'
        >
          { textPlaceHolder || 'Elija un cereal' }
        </option>
      ),
      ...cerealEspecies.map(cerealEspecie => {
        return (
          <option
            value={cerealEspecie.nombreCorto}
            key={cerealEspecie.nombreCorto}
          >
            {cerealEspecie.nombre}
          </option>
        )
      })
    ]
  };

  render () {
    const {
      isRequesting,
      disabled,
      required = false,
      textLabel = null,
      textPlaceHolder = null,
      fieldName = 'cereal'
    } = this.props

    return (
      <Field
        onChange={this.onSelect}
        name={fieldName || 'cereal'}
        label={textLabel || (required ? 'Cereal *' : 'Cereal')}
        disabled={disabled}
        component={renderSelectField}
        placeholder={textPlaceHolder || 'Elija un cereal'}
      >
        {!isRequesting ? this.renderCereales() : null}
      </Field>
    )
  }
}

const mapStateToProps = (state) => ({
  isRequesting: state.cereal.isRequestingCrealEspecies,
  cerealEspecies: state.cereal.cerealEspecies
})

const withRedux = connect(mapStateToProps, actions)
export default withRedux(CerealDropdown)
